// markerActiveState — der Aktiv-Zustand eines Karten-Markers an EINER Stelle: Farbe (CSS-Klasse) + Stapel-Position.
//
// Beides gehört zusammen: bei deckungsgleichen Verortungen (zwei Dokumente auf derselben Koordinate) nützt die
// grüne Aktiv-Farbe nichts, wenn der Marker unter einem anderen liegt.
//
// WARUM die zIndex-Property und nicht CSS: AdvancedMarkerElement stapelt über seine `zIndex`-Property — Google
// schreibt daraus den Stapelwert auf das Marker-Element, das den content-Div umschließt. Ein `z-index` am
// content-Div wirkt dann nur INNERHALB dieses Elements und hebt den Marker nicht über seine Nachbarn.

// Aktiver Marker liegt ganz vorn. Der Wert spiegelt Googles altes `Marker.MAX_ZINDEX` (1e6) — hoch genug, um die
// Standard-Sortierung (ohne zIndex: nach Bildschirm-Position, südlichster oben) sicher zu schlagen.
export const MARKER_Z_ACTIVE = 1000000;

/**
 * Aktiv-Zustand eines Markers setzen: Farbe + nach vorn holen.
 * @param {object} marker   AdvancedMarkerElement (oder ein Objekt mit .content und .zIndex)
 * @param {boolean} active
 */
export function setMarkerActiveState(marker, active) {
    if (!marker || !marker.content) { return; }
    const on = !!active;
    marker.content.classList.toggle('svgMarker--active', on);
    // null = zurück zur Standard-Sortierung. Kein Vorwert zu merken: auf diesen Markern setzt sonst niemand
    // zIndex (weder MarkerFactory noch der Clusterer) — täte er es, gehörte dieser Wert hierher.
    marker.zIndex = on ? MARKER_Z_ACTIVE : null;
}
